export default __webpack_public_path__ + "static/media/fic.65ee8f41.png";